import { TextField } from '@mui/material';
import { useController } from 'react-hook-form';

export type GuestJourneyStageNameFieldProps = {
  /** RHF field path, e.g. `visitTier1Label`. */
  name: string;
  label: string;
  /**
   * View-only mode. Uses readOnly rather than disabled so the name stays
   * legible, focusable, and announced by screen readers.
   */
  readOnly?: boolean;
  'data-testid'?: string;
};

/**
 * A single editable stage-name input bound to the settings form via
 * `useController` (reads the form from context). Surfaces the schema's
 * validation message inline when the name is empty or too long.
 */
const GuestJourneyStageNameField = ({
  name,
  label,
  readOnly = false,
  'data-testid': dataTestId,
}: GuestJourneyStageNameFieldProps) => {
  const { field, fieldState } = useController({ name });

  return (
    <TextField
      name={field.name}
      value={field.value ?? ''}
      onChange={field.onChange}
      onBlur={field.onBlur}
      inputRef={field.ref}
      size="small"
      label={label}
      error={!!fieldState.error}
      helperText={fieldState.error?.message}
      inputProps={{ 'data-testid': dataTestId }}
      slotProps={{ input: { readOnly } }}
    />
  );
};

export default GuestJourneyStageNameField;
